import React, {Component} from 'react'

import DynamicHeaderButtonComponent from './DynamicHeaderButton.component'

class DynamicHeaderButtonContainer extends Component {
    handleClick = (evt) => {
      evt.preventDefault()

      this.props.analytics.linkClick({
        text: this.props.label,
        type: 'Data Table'
      })

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Dynamic Action Button: ' + this.props.label,
        type: 'Datatable'
      })

      // if we have 0 items selected and a defined min length, bail out here (button will be grey anyway)
      if (this.props.minimumSelected > 0 && this.props.selectedRows < this.props.minimumSelected) {
        return false
      }

      /* const selectedDataRows = this.props.api.getFilteredItems().filter((dataItem) => {
        console.log(dataItem.uuid, this.props.selectedRows)
        return this.props.selectedRows.indexOf(dataItem.uuid) > -1
      }) */

      const filterPayload = {
        pagination: this.props.api.getPagination(),
        filters: this.props.api.getFilters(),
        sort: this.props.api.getSort(),
        search: this.props.api.getSearch()
      }

      this.props.env.callFunction(this.props.callback, [this.props.selectedRows, this.props.minimumSelected, filterPayload])
    }

    render() {
      const events = {
        handleClick: this.handleClick
      }

      return (
        <DynamicHeaderButtonComponent events={events} minimumSelected={this.props.minimumSelected} {...this.props} />
      )
    }
}

export default DynamicHeaderButtonContainer
